import React from 'react';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as S from './style';
import { Img } from 'components';
import FamilyMoveGuide from 'assets/img/guide/img_familymove_guide.jpg';
import FamilyMoveGuideM from 'assets/img/guide/img_familymove_guide_mobile.jpg';
import SmallMoveGuide from 'assets/img/guide/img_smallmove_guide.jpg';
import SmallMoveGuideM from 'assets/img/guide/img_smallmove_guide_mobile.jpg';

function AppGuide(): React.ReactElement {
  const { serviceType } = useParams<{ serviceType: string }>();

  return (
    <S.GuideContainer>
      <Img
        alt={'app_guide'}
        src={(() => {
          if (serviceType === 'smallmove' || serviceType === 'small_move') {
            return isMobile ? SmallMoveGuideM : SmallMoveGuide;
          } else {
            return isMobile ? FamilyMoveGuideM : FamilyMoveGuide;
          }
        })()}
      />
    </S.GuideContainer>
  );
}

export default AppGuide;
